import { filter_day, filter_month, filter_week } from '../../../../../views/marketing/overview/PeriodFilter';

export default {
  filters: {
    [filter_day]: 'Day',
    [filter_week]: 'Week',
    [filter_month]: 'Month',
    null: 'Total',
  },
};
